import { render } from "./PopupPanel.vue?vue&type=template&id=b9d2386c&ts=true"
import script from "./PopupPanel.vue?vue&type=script&lang=ts"
export * from "./PopupPanel.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__